import LanguageSelector from './Components/Language/LanguageSelector';
import ProductNavigation from './Components/Header/ProductNavigation';
import { useTranslation } from 'react-i18next';
import logo from './allianz-logo.png';

const PageLayout = ({ children, printButtonLabel = 'Print', supportedLanguages, defaultLanguage, language, moreLabel = 'More', navigationEntries = [] }) => {
	const { t } = useTranslation();
	return (
		<div>
			<div aria-label="Product Navigation" className="c-product-nav-bar js-toggle-product-nav">
				<div className="l-container l-container--full-width position-static">
					<div className="l-grid l-grid--max-width position-static">

						<div className="l-grid__row position-static">

							<div className="l-grid__column-12 c-product-nav-bar__container position-static">


								<h3 className="c-heading c-heading--subsection-xsmall c-product-nav-bar__heading js-toggle-product-nav__link"
									role="navigation"
									aria-label="open product navigation">
									<a href="/" className="c-header__logo ">
										<img src={logo} alt="logo" style={{ width: 120 }} />
									</a>

									<span aria-hidden="true" className="c-icon c-icon--chevron-down c-product-nav-bar__mobile-toggle"></span>
								</h3>

								{/* Navigation */}
								{navigationEntries.length > 0 && 
									<ProductNavigation navigationEntries={navigationEntries} moreLabel={moreLabel} />
								}


								{/* Print Button */}
								<button className="c-button c-button--secondary c-button--small c-product-nav-bar__button" onClick={() => window.print()}>
									{t('printButtonLabel')}
								</button>

								{/* Language Switcher */}
								<div className="c-header-metabar__descriptor" style={{ paddingTop: 10 }} >
									<LanguageSelector supportedLanguages={supportedLanguages} defaultLanguage={defaultLanguage} language={language} />
								</div>
							
							</div>
						</div>
					</div>
				</div>
			</div>

			{children}
		</div>
	)
};

export default PageLayout;
